import React, { Component } from 'react'
import { Icon } from '@driftt/tide-core-legacy'
import IconSVG from 'svg-inline-react'
import cx from 'classnames'

import './styles.styl'

class Accordion extends Component {
  state = {
    active: false,
  }
  renderDropDownIcon = () => (
    <i className="icon">
      <IconSVG src={require(`!svg-inline?removeTags=true!images/svg/ui-dropdown-caret.svg`)} />
    </i>
  )
  handleClick = () => {
    if (!this.props.locked) {
      this.setState({ active: !this.state.active })
    }
  }
  render() {
    const { active } = this.state
    const { children, title, locked, isConnected, centerLogo, className } = this.props
    const logoClass = centerLogo ? 'flex-center' : 'flex-space-between'
    return (
      <div className="accordion">
        <div
          className={cx('title', className, logoClass, { active: active || locked, locked })}
          onClick={this.handleClick}
        >
          {title}
          <div className="flex">
            {isConnected ? <Icon height={37} width={37} className="accordion-connected" name="check-circle"/> : null}
            <div style={{ minWidth: 20, alignSelf: 'center' }}>
              {locked ? null : this.renderDropDownIcon()}
            </div>
          </div>
        </div>
        <div className={cx('content', { active: active || locked })}>
          <div className="transition visible">{children}</div>
        </div>
      </div>
    )
  }
}

export default Accordion



// WEBPACK FOOTER //
// ./src/scripts/components/shared/Accordion/index.js